export const getCompanyFormTitle = (company: any) =>
  !company
    ? 'buttons.addSubsidiaryCompany'
    : company.parentCompanyId
    ? 'labels.subsidiaryCompanyProfile'
    : 'labels.parentCompanyProfile';

export const getFormInitialValues = (companyData: any) => ({
  ...companyData,
  locations:
    companyData.locations && companyData.locations.length > 0
      ? companyData.locations.map((item: any) => {
          const { datevNumber, ...rest } = item;

          return {
            ...rest,
            datevNumberId: datevNumber?._id,
          };
        })
      : [
          {
            businessAddresses: [
              {
                departments: [{}],
                street: companyData.street,
                city: companyData.city,
                zipCode: companyData.zipCode,
                country: companyData.country,
              },
            ],
          },
        ],
});
